var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.22C14.27 10.22 16.1101 8.37989 16.1101 6.11C16.1101 3.84011 14.27 2 12.0001 2C9.73025 2 7.89014 3.84011 7.89014 6.11C7.89014 8.37989 9.73025 10.22 12.0001 10.22Z",
    fill: "#3E4744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6551 23.0004H6.34512C5.39034 23.0004 4.47466 22.6211 3.79953 21.946C3.1244 21.2709 2.74512 20.3552 2.74512 19.4004C2.7471 17.3562 3.56004 15.3963 5.00552 13.9508C6.45099 12.5054 8.41091 11.6924 10.4551 11.6904H13.5451C15.5893 11.6924 17.5492 12.5054 18.9947 13.9508C20.4402 15.3963 21.2531 17.3562 21.2551 19.4004C21.2551 20.3552 20.8758 21.2709 20.2007 21.946C19.5256 22.6211 18.6099 23.0004 17.6551 23.0004Z",
    fill: "#F2859A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.73bf6637e6a54171b3de37058ccf077a.svg";
export { ForwardRef as ReactComponent };